export default __webpack_public_path__ + "static/index_hero_bg03-54d7d13c8f97c870c32c10a959b950b9.jpg";